<template>
  <!-- 中心概况 -->
  <div>
    <ContentLayout :columnsSubList="columnsSubList">
      <template slot="content">
        <!-- 动态内容 -->
        <component :is="pageCmp"></component>
      </template>
    </ContentLayout>
  </div>
</template>

<script>
// import { timelineConfig } from "../../api/aboutUs";
import ContentLayout from "../../components/contentLayout";
import IntroductionId from "./introduction/id";
import TimelineId from "./timeline/id";
export default {
  components: {
    ContentLayout,
    introduction: IntroductionId,
    timeline: TimelineId,
  },
  data() {
    return {
      pageCmp: "introduction", //默认显示第一个组件
      columnsSubList: {
        path: "",
        list: [],
      },
    };
  },
  created() {
    this.updateComponent();
  },
  methods: {
    // 菜单页面组件切换判断
    updateComponent() {
      const { path = "" } = this.$route;
      // 二级菜单页面
      this.pageCmp = path.split("/")[2];
    },
    
  },
  watch: {
    $route() {
      this.updateComponent();
    },
  },
};
</script>

<style scoped></style>
